<template>
  <header class="cabinet-page-header">
    <div>
      <span v-if="eyebrow">{{ eyebrow }}</span>
      <h1>{{ title }}</h1>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
    <slot />
  </header>
</template>

<script>
export default {
  name: 'CabinetPageHeader',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    eyebrow: { type: String, default: '' },
  },
}
</script>

<style lang="sass" scoped>
.cabinet-page-header
  display: flex
  align-items: flex-start
  justify-content: space-between
  gap: 16px
  margin-bottom: 20px

  span
    display: block
    margin-bottom: 6px
    color: #96883a
    font-size: 10px
    font-weight: 700
    letter-spacing: .14em
    text-transform: uppercase

  h1
    color: #292b25
    font-family: 'Mazzard Soft H', 'SFUIText', sans-serif
    font-size: 28px
    font-weight: 600
    line-height: 1.15
    letter-spacing: -.3px

  p
    max-width: 330px
    margin-top: 8px
    color: #777269
    font-size: 13px
    line-height: 1.45
</style>
